import { render, staticRenderFns } from "./ContentsListBasic.vue?vue&type=template&id=51f0145c"
import script from "./ContentsListBasic.vue?vue&type=script&lang=js"
export * from "./ContentsListBasic.vue?vue&type=script&lang=js"
import style0 from "./ContentsListBasic.vue?vue&type=style&index=0&id=51f0145c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports